<template lang="pug">
  b-row
    .col-xl-12
      panel(:title='$t("title.commission_settings")' :bodyClass="'childBody'")
        b-row
          .col-sm-12.col-md-12.col-lg-12.col-xl-12
            #tblModal.table-sm.table-responsive
              table.table.table-bordered
                tbody
                  tr(v-show="!isSearch")
                    th {{ comm_sportsbook_hdp_packages_title }}
                    td
                      b-form-select(
                        ref="comm_sportsbook_hdp_packages"
                        :options="comm_sportsbook_hdp_packages_options"
                        v-model.trim.lazy="comm_sportsbook_hdp_packages"
                        size="sm"
                        disabled
                      )
                  tr(v-if="show('A')")
                    th {{ $t("ui.combine.comm_limit_A") }}
                    td.text-center {{ comm_sportsbook_hdp_a }}%
                  tr(v-if="show('B')")
                    th {{ $t("ui.combine.comm_limit_B") }}
                    td.text-center {{ comm_sportsbook_hdp_b }}%
                  tr(v-if="show('C')")
                    th {{ $t("ui.combine.comm_limit_C") }}
                    td.text-center {{ comm_sportsbook_hdp_c }}%
                  tr(v-if="show('D')")
                    th {{ $t("ui.combine.comm_limit_D") }}
                    td.text-center {{ comm_sportsbook_hdp_d }}%
                  tr(v-if="show('E')")
                    th {{ $t("ui.combine.comm_limit_E") }}
                    td.text-center {{ comm_sportsbook_hdp_e }}%
                  tr(v-if="show('F')")
                    th {{ $t("ui.combine.comm_limit_F") }}
                    td.text-center {{ comm_sportsbook_hdp_f }}%
                  tr(v-if="show('I')")
                    th {{ $t("ui.combine.comm_limit_I") }}
                    td.text-center {{ comm_sportsbook_hdp_i }}%
                  tr(v-if="show('J')")
                    th {{ $t("ui.combine.comm_limit_J") }}
                    td.text-center {{ comm_sportsbook_hdp_j }}%
                  tr
                    th {{ $t("ui.oxt") + "/" + $t("ui.double_chance") }}
                    td.text-center {{ comm_sportsbook_1x2 }}%
                  tr
                    th {{ $t("ui.others") }}
                    td.text-center {{ comm_sportsbook_others }}%
                  template(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency)")
                    tr
                      th {{ $t("ui.hdp") + "/" + $t("ui.ou") + " MMO" }}
                      td.text-center {{ comm_hdp_mmo }}%
                    tr
                      th {{ $t("ui.combine.comm_parlay_mmo_a") }}
                      td.text-center {{ comm_parlay_mmo_a }}%
                    tr
                      th {{ $t("ui.combine.comm_parlay_mmo_b") }}
                      td.text-center {{ comm_parlay_mmo_b }}%
                  tr(v-show="isPlatformShow('LC')")
                    th {{ $t("ui.live_casino") }}
                      //- span.small.text-danger [{{ $t("ui.manila_nocomm") }}]
                      i.fa.fa-info-circle.text-danger.ml-1(
                        v-b-tooltip.hover.right="{ boundary: 'window', container: 'body' }"
                        :title="$t('ui.manila_nocomm')"
                      )
                    td.text-center {{ comm_casino }}%
                  tr(v-show="isPlatformShow('LO')")
                    th {{ $t("ui.lotto") }}
                    td.text-center {{ comm_lotto }}%
                  tr(v-show="isPlatformShow('KNno')")
                    th {{ $t("ui.keno") }}
                    td.text-center {{ comm_keno }}%
                  tr.d-none(v-show="isPlatformShow('CF')")
                    th {{ $t("ui.esports2") }}
                    td.text-center {{ comm_cockfight }}%
                  tr(v-show="isPlatformShow('LTno')")
                    th {{ $t("ui.lottery_1d") }}
                    td.text-center {{ comm_lottery_1d }}%
                  tr(v-show="isPlatformShow('LTno')")
                    th {{ $t("ui.lottery_2d") }}
                    td.text-center {{ comm_lottery_2d }}%
                  tr(v-show="isPlatformShow('LT')")
                    th {{ $t("ui.lottery_3d") }}
                    td.text-center {{ comm_lottery_3d }}%
                  tr(v-show="isPlatformShow('LT')")
                    th {{ $t("ui.lottery_4d") }}
                    td.text-center {{ comm_lottery_4d }}%
                  template(v-if="!$helpers.isAgentLevel()")
                    tr(v-show="isPlatformShow('KN')")
                      th {{ $t("ui.tournament") }}
                      td.text-center {{ comm_tournament }}%
</template>

<script>
export default {
  props: {
    accountID: "",
    platformList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      comm_sportsbook_hdp_a: 0,
      comm_sportsbook_hdp_b: 0,
      comm_sportsbook_hdp_c: 0,
      comm_sportsbook_hdp_d: 0,
      comm_sportsbook_hdp_e: 0,
      comm_sportsbook_hdp_f: 0,
      comm_sportsbook_hdp_g: 0,
      comm_sportsbook_hdp_h: 0,
      comm_sportsbook_hdp_i: 0,
      comm_sportsbook_hdp_j: 0,
      comm_sportsbook_1x2: 0,
      comm_sportsbook_others: 0,
      comm_sportsbook_hdp_packages: "A", //"A" or "A","B","C"
      comm_slots: 0,
      comm_casino: 0,
      comm_lotto: 0,
      comm_keno: 0,
      comm_cockfight: 0,
      comm_lottery_1d: 0,
      comm_lottery_2d: 0,
      comm_lottery_3d: 0,
      comm_lottery_4d: 0,

      comm_hdp_mmo: 0,
      comm_parlay_mmo_a: 0,
      comm_parlay_mmo_b: 0,
      comm_tournament: 0
    }
  },
  computed: {
    comm_sportsbook_hdp_packages_title: function() {
      return this.$t("ui.hdp_packages")
    },
    comm_sportsbook_hdp_packages_options: function() {
      let packages = ["A","B","C","D","E","F"]
      let result = []
      if(packages) {
        packages.sort().forEach((value, index) => {
          result.push({value:value, text:this.$t("ui.combine.comm_limit_" + value)})
        })
      }
      return result
    }
  },
  methods: {
    show: function(mode) {
      let result = false
      if(this.accountID.length > 8) {
        if (this.comm_sportsbook_hdp_packages == mode){
          result = true
        }
      } else {
        if(this.comm_sportsbook_hdp_packages.length > 1) {
          this.comm_sportsbook_hdp_packages.split(",").forEach((value) => {
            if (value == mode){
              result = true
            }
          })
        } else {
          if (this.comm_sportsbook_hdp_packages == mode){
            result = true
          }
        }
      }
      return result
    },
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    isPlatformShow: function(mode) {
      switch(mode){
        case "LC":
          return this.platformList.includes("LIVECASINO")
        case "SL":
          return this.platformList.includes("SLOTS")
        case "LO":
          return this.platformList.includes("LOTTO")
        case "KN":
          return this.platformList.includes("KENO")
        case "CF":
          return this.platformList.includes("COCKFIGHT")
        case "LT":
          return this.platformList.includes("LOTTERY")
      }
    }
  }
}
</script>